import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgramariUltimaOraComponent } from './programari-ultima-ora.component';
import { AddProgramariUltimaOraComponent } from './add-programari-ultima-ora/add-programari-ultima-ora.component';
import { EditProgramariUltimaOraComponent } from './edit-programari-ultima-ora/edit-programari-ultima-ora.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';

@NgModule({
    declarations: [
        ProgramariUltimaOraComponent,
        AddProgramariUltimaOraComponent,
        EditProgramariUltimaOraComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        NgxMatTimepickerModule
    ],
    exports: [ProgramariUltimaOraComponent]
})
export class ProgramariUltimaOraModule { }
